import React from 'react';
import ClusterService from '../../../../lib/api/cluster/clusterService';
import TemplateParametro from '../shared/templateParametros/templateParametros';

class Cluster extends React.Component<{},{}> 
{
    constructor(props: any)
    {
        super(props);
        this.state = {};
    }

    baixarExcelCluster()
    {
        return ClusterService.obterExcel();
    }

    enviarParametrosEventGrid()
    {
        return ClusterService.enviarParametrosAoEventGrid();
    }

    render()
    {
        return (
            <TemplateParametro
                enviarParametrosEventGrid={this.enviarParametrosEventGrid}
                baixarExcelParametros={this.baixarExcelCluster}
                enviarExcelParametros={ClusterService.clusterExcelPost}
                deletarExcelParametros={ClusterService.deletarExcelParametros}
                nomeDoArquivo='Parâmetro Cluster Unitário'
            ></TemplateParametro>
        );
    }
}

export default Cluster;